import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Typography, Stack } from "@mui/material";
import { logEvent } from "services/amplitude.service";
import { useQuickSearch } from "./hooks/use-quick-search.hook";
import { Preferences, useUserData } from "features/User";

const QuickSearchResults = () => {
  const { groupId, gradeLicenseLevel, groupPreferences } = useUserData();
  const { searchList, getQuickSearch } = useQuickSearch();
  const isQuickSearchVisible = useMemo(() => {
    if (groupId != null) {
      if (
        groupPreferences != null &&
        groupPreferences[Preferences.HIDE_QUICK_SEARCH] != null &&
        gradeLicenseLevel != null
      ) {
        return typeof groupPreferences[Preferences.HIDE_QUICK_SEARCH][
          gradeLicenseLevel
        ] !== "boolean"
          ? false
          : !groupPreferences[Preferences.HIDE_QUICK_SEARCH][gradeLicenseLevel];
      }
    }

    return true;
  }, [groupPreferences, gradeLicenseLevel, groupId]);
  return isQuickSearchVisible && searchList.length ? (
    <Box
      sx={{
        backgroundColor: "secondary.main",
        p: "5rem",
        borderRadius: "10px",
        color: "text.primary",
        width: { xs: "100%", md: "75rem" },
        display: "flex",
        flexDirection: "column",
      }}
      id="tour-quick-search"
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: "2rem" }}
      >
        <Typography variant="h6" color="text.secondary" className="quick-search-title">
          Quick Search
        </Typography>
        <RefreshIcon
          sx={{
            fontSize: "2rem",
            color: "text.secondary",
            cursor: "pointer",
          }}
          onClick={() => getQuickSearch(true)}
        />
      </Stack>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" },
          gap: "2rem",
        }}
      >
        {searchList.map((item) => {
          const itemURL = new URL(item.link_chr);
          return (
            <Link
              to={`${itemURL.pathname}${itemURL.search}`}
              key={item.quickSearch_chr}
              onClick={() => {
                logEvent(`click_curious_query`, {
                  quicksearch: item.link_chr,
                });
              }}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              {item.quickSearch_chr}
            </Link>
          );
        })}
      </Box>
    </Box>
  ) : null;
};

export default QuickSearchResults;
